export enum ButtonTheme {
  Basic = 'mat-button',
  Raised = 'mat-raised-button',
  Stroked = 'mat-stroked-button',
  Flat = 'mat-flat-button',
  Icon = 'mat-icon-button',
  Fab = 'mat-fab',
  MiniFab = 'mat-mini-fab'
}
